import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DataPage.css';

import { API_URL } from '../config';

function Setores() {
  const [setores, setSetores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSetores();
  }, []);

  const fetchSetores = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/setores`);
      setSetores(response.data || []);
    } catch (err) {
      console.error('Erro ao buscar setores:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (value === 'T' || value === 't') return 'Sim';
    if (value === 'F' || value === 'f') return 'Não';
    return String(value);
  };

  const formatTime = (timeString) => {
    if (!timeString) return '-';
    // Extrair apenas HH:MM:SS da string
    const timeMatch = timeString.match(/(\d{2}):(\d{2}):(\d{2})/);
    if (timeMatch) {
      return `${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}`;
    }
    return timeString;
  };

  if (loading) {
    return <div className="loading">Carregando setores...</div>;
  }

  const styles = {
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
  };

  return (
    <div className="data-page">
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🏢</span>
          <div>
            <h1 style={styles.pageTitle}>Setores</h1>
            <p style={styles.pageSubtitle}>Total: {setores.length} setores cadastrados</p>
          </div>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descrição</th>
              <th>Tempo de Alerta</th>
              <th>Emite Alerta</th>
            </tr>
          </thead>
          <tbody>
            {setores.map((setor) => (
              <tr key={setor.ID}>
                <td><strong>{setor.ID}</strong></td>
                <td><strong>{setor.DESCRICAO}</strong></td>
                <td>{formatTime(setor.TEMPO_ALERTA)}</td>
                <td>{formatarValor(setor.EMITE_ALERTA)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {setores.length === 0 && !loading && (
        <div className="no-data">
          <p>Nenhum setor encontrado.</p>
        </div>
      )}
    </div>
  );
}

export default Setores;
